import { QueryKeys } from '@/constants/QueryKeys';
import { RetailerApi } from '@/utilities/api/RetailerApi';
import { ProductApi } from '@/utilities/api/ProductApi';
import { useQuery } from 'react-query';
import { CategoryEndPoint, ManufacturerEndpoint, RetailerEndpoint } from "@api/endpoints";

export const useCategoryList = (query?: CategoryEndPoint.List.Query) => {
  const { data: response, isLoading } = useQuery(
    [QueryKeys.GET_CATEGORY, query],
    () => ProductApi.getCategories(query),
  );
  const categoryList = response?.data;
  return {
    isLoading,
    categoryList,
  };
};

export const useManufacturerList = (query?: ManufacturerEndpoint.List.Query, options?: {
  enabled: boolean,
}) => {
  const { data: manufacturerList, isLoading } = useQuery(
    [QueryKeys.GET_MANUFACTURERS_LIST, query],
    () => ProductApi.getManufacturers(query),
    options,
  );
  return {
    isLoading,
    manufacturerList,
  };
};

export const useGetRetailerList = (
  query?: RetailerEndpoint.RetailerList.Query,
  options?: {
    enabled?: boolean,
    onSuccess?: (data: RetailerEndpoint.RetailerList.Response) => void,
  },
) => {
  const { data: retailerList, isLoading } = useQuery(
    [QueryKeys.ACTIVE_RETAILERS, query],
    () => RetailerApi.getActiveRetailerLists(query ?? {}),
    options,
  );
  return {
    isLoading,
    retailerList,
  };
};
